import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ebooks } from "./ebooksData";
import EbookModal from "./ebookpopup/EbookModal";
import { motion } from "motion/react";
import { ArrowRight } from "lucide-react";
import { Helmet } from "react-helmet";
const Ebooks = () => {
  const [selectedEbook, setSelectedEbook] = useState(null);

  return (
    <>
      <Helmet>
        <title>AI, Salesforce & Data Ebooks | Marketing Insights Pune</title>

        <meta
          name="description"
          content="Download AI, Salesforce & Martech ebooks by Comsense. Get insights on data, automation & customer experience strategies."
        />

        <meta
          name="keywords"
          content="AI ebooks India, Salesforce ebooks Pune, marketing analytics ebooks, data analytics guides India"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="AI, Salesforce & Data Ebooks India | Marketing Insights by Comsense"
        />
        <meta
          property="og:description"
          content="Free ebooks on AI, Salesforce, data analytics & Martech strategies."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://comsensetechnologies.com/ebooks"
        />
      </Helmet>
      <style>{`
        .ebooks-page { font-family: 'Outfit', sans-serif; 
        font-family: 'Outfit', sans-serif; background-color: #f8fafc;
        }
          .ebook-hero {
          padding: 100px 0 100px;
          background: #e2f1fe;
          color: #fff;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-title-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          max-width: 600px;
        }

        .ebook-hero h1 {
          font-weight: 800;
          margin-bottom: 10px;
          font-size: 42px;
          text-align: left;
          color: #0f172a;
          letter-spacing: -.5px;
        }

        .ebook-hero p {
          font-size: 16px;
          color: #475569;
          text-align: left;
          max-width: 900px;
          margin-bottom: 0px;
        }

        .hero-icon {
          position: absolute;
          top: 50%;
          right: 10%;
          transform: translateY(-50%);
          opacity: 0.2;
          pointer-events: none;
        }

        .ebook-listing { padding: 80px 0; }
        .ebook-card { 
         height: 100%;
  display: flex;
  flex-direction: column; transition: all 0.4s ease;
       background: #fff;
          border-radius: 0;
          border: none;
          overflow: hidden;
          transition: all 0.4s ease;
          height: 100%;
          display: flex;
          flex-direction: column;   }
        .ebook-card:hover { transform: translateY(-6px); border-color: #e00; }
        .ebook-card img { width: 100%; height: 220px; object-fit: cover; }
        .ebook-card-body {     padding: 10px;
          flex-grow: 1;
          display: flex;
          flex-direction: column; }
        .ebook-title { 
             font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 15px;
          line-height: 1.4;
        }
      .ebook-actions
        {
       margin-top: auto;
          padding-top: 15px;
          margin-left:0px; 
      }
        .ebook-excerpt { color: #d1d5db; margin-bottom: 14px; }
        .ebook-actions a, .ebook-actions button { margin-right: 8px; margin-bottom: 6px; text-decoration: none; color: #fff; background: #ee0000; border: 0; border-radius: 8px; padding: 8px 14px; font-weight: 600; font-size:14px; cursor: pointer; }
      
        .ebook-actions a, .ebook-actions button { 
        margin-right: 8px; 
        margin-bottom: 0px;
         text-decoration: none; color: #ee0000; background: transparent; border: 0; border-radius: 8px; padding: 8px 14px 0px 14px; font-weight: 600; font-size:14px; cursor: pointer; padding-left:0; 
    
         }

         .ebook-actions button { 
display: flex;
  align-items: center;        
         }
      
        .ebook-actions a.details { color: #e00;
  background: #fff;
  border: 1px solid #e00; 
  }

      .ebook-hero {
          padding: 100px 0 100px;
          background: #e2f1fe;
          color: #fff;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-title-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          max-width: 600px;
        }

        .ebook-hero h1 {
          font-weight: 800;
          margin-bottom: 10px;
          font-size: 42px;
          text-align: left;
          color: #0f172a;
          letter-spacing: -.5px;
        }

        .ebook-hero p {
          font-size: 16px;
          color: #475569;
          text-align: left;
          max-width: 900px;
          margin-bottom: 0px;
        }

        .hero-monitor-icon {
          position: absolute;
          top: 50%;
          right: 10%;
          transform: translateY(-50%);
          opacity: 0.2;
          pointer-events: none;
        }
          .ebook-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
  .ebook-card-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
  .ebook-actions {
  margin-top: auto;
}
      `}</style>
      <div className="ebooks-page">
        <section className="ebook-hero">
          <Container>
            <div className="hero-title-container">
              <motion.div
                className="hero-title-container"
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h1>E-books</h1>
                <p>Charting Expertise To Meaningful Insights</p>
              </motion.div>
              <div className="hero-monitor-icon">
                <svg
                  width="200"
                  height="200"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
            </div>
          </Container>
        </section>

        <section className="ebook-listing">
          <Container>
            {ebooks.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">No ebooks available at the moment.</p>
              </div>
            ) : (
              <Row className="g-4">
                {ebooks.map((ebook, index) => (
                  <Col md={6} lg={4} key={ebook.id} className="d-flex">
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      viewport={{ once: true }}
                    >
                      <div className="ebook-card">
                        <img
                          src={ebook.image}
                          alt={ebook.title}
                          className="card-img-top"
                        />
                        <div className="ebook-card-body">
                          <h5 className="ebook-title">{ebook.title}</h5>
                          <p className="ebook-excerpt">{ebook.excerpt}</p>
                          <div className="ebook-actions">
                            {/* <Link
                              to={`/ebook/${ebook.slug}`}
                              className="details"
                            >
                              View E-book
                            </Link> */}
                            <button onClick={() => setSelectedEbook(ebook)}>
                              Download pdf{" "}
                              <ArrowRight className="ms-2" size={14} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            )}
          </Container>
        </section>

        {selectedEbook && (
          <EbookModal
            show={!!selectedEbook}
            onHide={() => setSelectedEbook(null)}
            ebookTitle={selectedEbook.title}
            ebookPdfFile={selectedEbook.pdfFile}
          />
        )}
      </div>
    </>
  );
};

export default Ebooks;
